import React from 'react';
import { SmartphoneIcon, MonitorIcon, PaintBucketIcon, CodeIcon, ServerIcon, BrainCircuitIcon, SparklesIcon, TrendingUpIcon, ShieldIcon } from 'lucide-react';
export function Services() {
  const traditionalServices = [{
    icon: <MonitorIcon size={32} className="text-blue-600" data-id="element-190" />,
    title: 'Web Development',
    description: 'Responsive, fast, and accessible websites built with modern technologies.'
  }, {
    icon: <SmartphoneIcon size={32} className="text-red-500" data-id="element-191" />,
    title: 'Mobile Apps',
    description: 'Native and cross-platform mobile applications for iOS and Android.'
  }, {
    icon: <PaintBucketIcon size={32} className="text-yellow-500" data-id="element-192" />,
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive interfaces with clean and functional design principles.'
  }, {
    icon: <CodeIcon size={32} className="text-green-500" data-id="element-193" />,
    title: 'Custom Software',
    description: 'Bespoke software solutions tailored to your specific business needs.'
  }, {
    icon: <ServerIcon size={32} className="text-indigo-500" data-id="element-194" />,
    title: 'Backend Systems',
    description: 'Robust, scalable backend infrastructure and API development.'
  }];
  const aiCapabilities = [{
    icon: <BrainCircuitIcon size={32} className="text-purple-600" data-id="element-195" />,
    title: 'Custom AI Solutions',
    description: 'We build tailored AI solutions that solve your unique business challenges, from predictive analytics to natural language processing.'
  }, {
    icon: <SparklesIcon size={32} className="text-blue-600" data-id="element-196" />,
    title: 'Intelligent UX',
    description: 'Enhance user experiences with AI-powered personalization, recommendations, and smart interfaces that adapt to user behavior.'
  }, {
    icon: <TrendingUpIcon size={32} className="text-green-600" data-id="element-197" />,
    title: 'Business Intelligence',
    description: 'Transform your data into actionable insights with our AI-driven analytics and reporting solutions.'
  }, {
    icon: <ShieldIcon size={32} className="text-red-600" data-id="element-198" />,
    title: 'Ethical AI',
    description: 'We develop AI with a focus on transparency, fairness, and privacy, ensuring responsible implementation.'
  }];
  return <section id="services" className="py-20 bg-gray-50" data-id="element-199">
      <div className="container mx-auto px-4" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-202">
            Our Services & Capabilities
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6" data-id="element-203"></div>
          <p className="max-w-2xl mx-auto text-gray-600" data-id="element-204">
            We offer a complete range of digital services and AI capabilities,
            combining technical excellence with thoughtful design sensibilities.
          </p>
        </div>
        {/* Traditional Services */}
        <div className="mb-20" data-id="element-205">
          <h3 className="text-2xl font-semibold text-gray-800 mb-8 text-center" data-id="element-206">
            Digital Services
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-207">
            {traditionalServices.map((service, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-208">
                <div className="mb-4" data-id="element-209">{service.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-210">
                  {service.title}
                </h3>
                <p className="text-gray-600" data-id="element-211">{service.description}</p>
              </div>)}
          </div>
        </div>
        {/* AI Capabilities */}
        <div className="mt-16" data-id="element-212">
          <h3 className="text-2xl font-semibold text-gray-800 mb-8 text-center" data-id="element-213">
            AI Capabilities
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-214">
            {aiCapabilities.map((capability, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg border border-gray-100 hover:shadow-md transition-shadow" data-id="element-215">
                <div className="mb-4" data-id="element-216">{capability.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-217">
                  {capability.title}
                </h3>
                <p className="text-gray-600" data-id="element-218">{capability.description}</p>
              </div>)}
          </div>
        </div>
        <div className="mt-16 bg-white p-8 md:p-12 rounded-lg border border-gray-100 shadow-sm" data-id="element-219">
          <div className="flex flex-col md:flex-row items-center gap-10" data-id="element-220">
            <div className="md:w-1/2 order-2" data-id="element-221">
              <h3 className="text-3xl font-bold text-gray-900 mb-5" data-id="element-222">
                Our Consulting Approach
              </h3>
              <p className="text-gray-600 mb-8 text-lg leading-relaxed" data-id="element-223">
                We don't just deliver designs — we engage deeply with your team,
                map your highest-impact opportunities, and ship measurable
                results within 90 days.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-224">
                <li className="flex items-start gap-3" data-id="element-225">
                  <span className="mt-2 w-2.5 h-2.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-226"></span>
                  <span className="text-gray-700" data-id="element-227">
                    Strategic roadmap & opportunity mapping
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-228">
                  <span className="mt-2 w-2.5 h-2.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-229"></span>
                  <span className="text-gray-700" data-id="element-230">
                    Custom implementation & integration
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-231">
                  <span className="mt-2 w-2.5 h-2.5 rounded-full bg-blue-600 flex-shrink-0" data-id="element-232"></span>
                  <span className="text-gray-700" data-id="element-233">
                    Team training & change management
                  </span>
                </li>
              </ul>
              <a href="#contact" className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:text-blue-700 transition-colors" data-id="element-234">
                Discuss your needs <span aria-hidden="true" data-id="element-235">→</span>
              </a>
            </div>
            <div className="md:w-1/2 order-1" data-id="element-236">
              <img src="https://images.unsplash.com/photo-1542626991-cbc4e32524cc?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80" alt="Team mapping ideas on a wall of sticky notes" className="rounded-lg shadow-md w-full aspect-[4/3] object-cover" data-id="element-237" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}